import React, { lazy, Component } from 'react';
import { SectionHeader, Button, FadeIn } from '../ui';
export function Team() {
  const team = [{
    name: 'Adam Marcolina',
    role: 'Director',
    desc: 'Qualified carpenter from age 18, leads the team, strong design eye.'
  }, {
    name: 'Daniel Marcolina',
    role: 'Director',
    desc: 'Registered builder at 21, close to 30 years experience, has supported over 1,400 Atrium clients.'
  }, {
    name: 'Tony Galante',
    role: 'Sales Manager',
    desc: '22+ years in building, champions a transparent and honest sales process.'
  }, {
    name: 'Joseph Opacak',
    role: 'Design Manager',
    desc: 'Nearly 30 years in WA residential design, award-recognised architectural talent.'
  }];
  return <section id="team" className="py-16 md:py-24 bg-atrium-ivory scroll-mt-24" data-id="element-316">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-317">
        <FadeIn data-id="element-318">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-319">
            <SectionHeader eyebrow="The People" title="Three generations, one team" className="mb-0" data-id="element-320" />
            <Button variant="secondary" as="a" href="/our-team/" data-id="element-321">
              Meet the team
            </Button>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-322">
          {team.map((member, index) => <FadeIn key={index} delay={index * 100} data-id="element-323">
              <div className="group" data-id="element-324">
                <div className="relative aspect-[3/4] overflow-hidden mb-6 bg-atrium-stone/20" data-id="element-325">
                  {/* <!-- swap = real headshot placeholder --> */}
                  <img src={`https://images.unsplash.com/photo-[PLACEHOLDER]?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80`} alt={member.name} width={600} height={800} loading="lazy" className="object-cover w-full h-full grayscale group-hover:grayscale-0 transition-all duration-800 opacity-0 group-hover:opacity-100" onError={e => {
                // Fallback for placeholder
                e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=D8D2C4&color=231F20&size=600&font-size=0.33`;
                e.currentTarget.classList.remove('opacity-0');
              }} data-id="element-326" />
                  <div className="absolute inset-0 border border-atrium-ink/10 pointer-events-none" data-id="element-327" />
                </div>
                <h3 className="font-serif text-xl text-atrium-ink mb-1" data-id="element-328">
                  {member.name}
                </h3>
                <span className="block text-xs font-bold tracking-wider text-atrium-green uppercase mb-3" data-id="element-329">
                  {member.role}
                </span>
                <p className="text-sm text-atrium-ink/70 leading-relaxed" data-id="element-330">
                  {member.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}